import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Field, Form } from 'react-final-form'
import { List } from 'immutable'
import isEmpty from 'lodash.isempty'
import ClearIcon from '@material-ui/icons/Clear'
import cn from 'classnames'
import {
  Button,
  Button as MaterialButton,
  Checkbox as CheckboxComponent,
  FormControl,
  FormControlLabel,
  Icon,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'
import Tags from '@yaireo/tagify/dist/react.tagify'
import '@yaireo/tagify/dist/tagify.css'
import { makeStyles } from '@material-ui/core/styles'
import IconBack from '@material-ui/icons/ArrowBack'
import IconAdd from '@material-ui/icons/Add'
import IconDelete from '@material-ui/icons/Delete'
import IconUploadFile from '@material-ui/icons/CloudUpload'
import withPromise from 'helpers/withPromise'
import Input from 'components/common/Form/Input'
import TextEditor from 'components/common/TextEditor'
import { Flex, InvalidEmptyValue } from 'components/common/styles'
import { Checkbox, Select } from 'components/common/FormInputs'
import SelectInput from 'components/common/Form/SelectInput'
import SelectList from 'components/common/SelectList'
import NoticeHelper from 'helpers/notice'
import { removeUnnecessaryProps } from 'helpers/formatter'
import { showNotice } from 'reducers/notice'
import {
  TYPE_ARRAY,
  TYPE_FORMULA,
  TYPE_INPUT_BOOLEAN,
  TYPE_INPUT_CALCULATED,
  TYPE_INPUT_DATE,
  TYPE_INPUT_DATE_TIME,
  TYPE_INPUT_FILE,
  TYPE_INPUT_MULTIPLE_FILES,
  TYPE_INPUT_NUMBER,
  TYPE_INPUT_SIGNATURE,
  TYPE_INPUT_TEXT,
  TYPE_INPUT_TIME,
  TYPE_SELECT,
} from 'helpers/jobs'
import getValidator, {
  VALIDATOR_IS_EMPTY,
  VALIDATOR_IS_INVALID_RANGE,
  VALIDATOR_IS_LESS_THEN_255_SYMBOLS,
  VALIDATOR_IS_POSITIVE_INTEGER,
  VALIDATOR_IS_YOUTUBE_LINK,
} from 'validation'
import {
  fetchAllowedLookupColumns,
  fetchDependencyInputs,
  fetchInputsOptionsSource,
  fetchInputTypes,
  fetchJobWorkflowInputGroups,
  fetchJobWorkflowInputItem,
  fetchJobWorkflows,
  fetchJobWorkflowTasks,
  fetchLookupConditions,
  fetchLookupTablesSource,
  fetchTaskNumberInputs,
  jobInputsClearDetails,
  saveJobInputsInfo,
} from 'reducers/jobInputsAdmin/reducer'
import { uploadFiles } from 'reducers/common/files/reducer'
import { MY_JOBS_UPLOAD_FILES } from 'constants/apiRouting'
import Psfs from 'lib/psfs/Psfs'
import {
  APP_LANGUAGES,
  LOOKUP_DISPLAY_TYPE,
  LOOKUP_UPDATE_TYPE,
  NUMBER_INPUT_CONDITION_TYPES,
  STRING_OR_DATE_INPUT_CONDITION_TYPES,
} from 'constants/index'
import TitleInput from 'components/common/TitleInput/TitleInput'
import TextArea from 'components/common/Form/TextArea'
import CheckboxInput from 'components/common/Form/CheckboxInput'
import messages from '../../translate'
import { StyledQuestionIcon } from './JobSingleInput.styles'

const PARAMETER_IMAGES = 'images'
const PARAMETER_OPTIONS = 'options'
const PARAMETER_DECIMALS = 'decimals'
const PARAMETER_OPTIONS_SOURCE = 'options_source'
const PARAMETER_BARCODE = 'barcode'
const PARAMETER_MIN_LENGTH = 'min_length'
const PARAMETER_MAX_LENGTH = 'max_length'
const PARAMETER_NUMBERS_ONLY = 'numbers_only'
const PARAMETER_LONGTEXT = 'longtext'
const PARAMETER_MULTIPLE = 'multiple'
const PARAMETER_SELECT_ALL = 'select_all'
const PARAMETER_DYNAMIC_OPTIONS_ALLOWED = 'dynamic_options'
const PARAMETER_LOOKUP_TABLES_SOURCE = 'lookup_table_source'
const PARAMETER_DEPENDENCY = 'dependency'

const DISPLAY_OPTIONS = ['list', 'horizontal_scroll', 'dropdown']

const useStyles = makeStyles({
  picture_option: {
    width: '100%',
    marginBottom: '10px',
  },
  image_wrap: {
    position: 'relative',
    marginTop: '30px',
  },
  remove_icon: {
    position: 'absolute',
    right: 0,
    bottom: '5px',
    cursor: 'pointer',
    background: '#FFFFFF',
  },
  simple_option: {
    width: '100%',
  },
  picture_option_invalid: {
    width: '100%',
    borderColor: '#FB404B',

    '& >label': {
      color: '#FB404B !important',
    },

    '& .MuiInput-underline:after': {
      borderBottom: '1px solid #FB404B',
      transform: 'none',
    },

    '& .MuiInput-underline:hover:before': {
      border: 'none',
    },
  },
  form_inside: {
    padding: '15px',
    backgroundColor: 'lavender',
  },
  options_item: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',

    '& .option-input': {
      width: '100%',
    },

    '& .btn-remove-input': {
      marginLeft: '10px',
    },
  },
  file_input: {
    display: 'none',
  },
  field_input: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '10px',
    border: '1px solid rgba(0, 0, 0, 0.42)',
  },
  field_icon: {
    marginRight: '15px',
  },
  field_image: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#D2D2E6',
    padding: '15px',

    '& .field-image-box': {
      width: '100%',
      marginRight: '15px',
    },
  },
})

// eslint-disable-next-line max-statements
function JobSingleInput({
  jobWorkflows,
  jobWorkflowTasks,
  jobWorkflowInputGroups,
  dependencyInputs,
  numberInputs,
  inputTypes,
  formData,
  allowedTableColumns,
  inputOptionsSource,
  inputLookupTablesSource,
  inputLookupConditions,
  showNotice,
  uploadFiles,
  saveJobInputsInfo,
  fetchInputTypes,
  fetchTaskNumberInputs,
  fetchJobWorkflows,
  fetchJobWorkflowTasks,
  fetchJobWorkflowInputGroups,
  fetchJobWorkflowInputItem,
  fetchInputsOptionsSource,
  fetchLookupTablesSource,
  fetchLookupConditions,
  fetchAllowedLookupColumns,
  fetchDependencyInputs,
  jobInputsClearDetails,
  history: { goBack },
  location: { search },
  intl: { formatMessage },
  match: { params: { id = '' } = {} },
  featureFlags,
}) {
  const classes = useStyles()
  const getEntityId = () => (id !== 'create' ? id : false)

  const tagifyRef = useRef()
  const langFields = {}
  Object.values(APP_LANGUAGES).forEach(({ key }) => {
    langFields[key] = ''
  })

  const [dependencyFormOpened, setDependencyFormOpened] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const [isNumberInputsLoaded, setIsNumberInputsLoaded] = useState(false)
  const [jobWorkflow, setJobWorkflow] = useState(null)
  const [jobTask, setJobTask] = useState(null)
  const [inputGroup, setInputGroup] = useState(null)
  const [selectDisplayType, setSelectDisplayType] = useState('list')
  const [parameters, setParameters] = useState([])
  const [
    activeLookupTableColumnList,
    setActiveLookupTableColumnList,
  ] = useState([])
  const [activeLookupTableColumn, setActiveLookupTableColumn] = useState(null)
  const [activeLookupTable, setActiveLookupTable] = useState(null)
  const [inputType, setInputType] = useState(null)
  const [canSetCurrentDatetime, setCanSetCurrentDatetime] = useState(true)
  const [isLookupString, setIsLookupString] = useState(false)
  const [equalToSiteName, setEqualToSiteName] = useState(false)
  const [isLookupNumber, setIsLookupNumber] = useState(false)
  const [isLookupDate, setIsLookupDate] = useState(false)
  const [isCreatesNewRowChecked, setIsCreatesNewRowChecked] = useState(false)
  const [parameterValue, setParameterValue] = useState('')
  const [dynamicOptions, setDynamicOption] = useState([langFields])
  const [displayConditions, setDisplayConditions] = useState(false)
  const [enTitle, setEnTitle] = useState('')
  const [dynamicImages, setDynamicImages] = useState([
    {
      path: '',
      title: langFields,
      description: langFields,
    },
  ])
  const { parameters: formDataParams = {} } = formData.toJS()
  const initialLanguages = {}
  const isParameterOptionSource = parameterValue === PARAMETER_OPTIONS_SOURCE
  const isParameterLookupTablesSource =
    parameterValue === PARAMETER_LOOKUP_TABLES_SOURCE
  const isParameterImages = parameterValue === PARAMETER_IMAGES
  const isParameterOptions = parameterValue === PARAMETER_OPTIONS
  const isStringInput = inputType === TYPE_INPUT_TEXT

  Object.values(APP_LANGUAGES).forEach(({ key }) => {
    initialLanguages[key] = ''
  })

  const [formState, setFormState] = useState({
    title: initialLanguages,
    workflow: null,
    task: null,
    input_group: null,
    type: '',
    position: 0,
    enabled: true,
    required: false,
    job_preview: false,
    task_preview: false,
    short_name: initialLanguages,
    instructions: initialLanguages,
    image_path: '',
    youtube_video_link: '',
    parameters: {
      can_only_take_pictures_in_mobile_app: false,
      unchangeable_time: false,
    },
  })
  const inputTypeList = inputTypes.toArray()
  const inputTypeOptions = inputTypeList.some(
    ({ type }) => type === TYPE_INPUT_MULTIPLE_FILES,
  )
    ? inputTypeList
    : [...inputTypeList, { type: TYPE_INPUT_MULTIPLE_FILES }]
  const hasEntityId = !!getEntityId()
  const editableDisabled =
    (canSetCurrentDatetime && inputType === TYPE_INPUT_DATE) ||
    isCreatesNewRowChecked

  useEffect(
    () => () => {
      jobInputsClearDetails()
    },
    [],
  )

  useEffect(() => {
    const entityId = getEntityId()
    const psfs = new Psfs()
    psfs.addSort('title')

    fetchJobWorkflows({ psfs })
    fetchInputTypes()

    if (entityId) {
      fetchJobWorkflowInputItem({ entityId })
    }
  }, [])

  useEffect(() => {
    if (
      inputType &&
      (inputType === TYPE_INPUT_DATE || inputType === TYPE_INPUT_DATE_TIME) &&
      !!jobTask
    ) {
      const psfs = new Psfs()
      const { id: inputId } = formData.toJS()
      const { dependency } = formDataParams || {}

      psfs.addFilter('task', jobTask)
      psfs.addFilter('type', TYPE_INPUT_DATE, 'in')

      if (inputType === TYPE_INPUT_DATE_TIME) {
        psfs.addFilter('type', [TYPE_INPUT_DATE_TIME, TYPE_INPUT_DATE], 'in')
      }

      if (inputId) {
        psfs.addFilter('except_id', inputId)
      }

      if (dependency) {
        setDependencyFormOpened(true)
      }

      fetchDependencyInputs({ psfs })
    }
  }, [inputType, jobTask])

  useEffect(() => {
    if (jobWorkflow) {
      const psfs = new Psfs()
      psfs.addFilter('workflow', jobWorkflow).addSort('title')

      fetchJobWorkflowTasks({ psfs })
    }
  }, [jobWorkflow])

  useEffect(() => {
    if (jobTask) {
      const psfs = new Psfs()
      psfs.addFilter('task', jobTask).addSort('id')

      fetchJobWorkflowInputGroups({ psfs })
      withPromise(fetchTaskNumberInputs, {
        entityId: jobTask,
        inputGroup,
      }).then(() => {
        setIsNumberInputsLoaded(true)
      })
    }
  }, [jobTask, inputGroup])

  useEffect(() => {
    if (redirect) {
      goBack()
    }
  }, [redirect, goBack])

  useEffect(() => {
    if (inputType && !parameters.length) {
      const type = inputTypeList.find(item => item.type === inputType)

      if (type) {
        setParameters(type.parameters)
      }
    }
  }, [inputTypeList])

  useEffect(() => {
    if (isParameterOptionSource) {
      fetchInputsOptionsSource()
    }
  }, [parameterValue])

  useEffect(() => {
    if (
      isParameterLookupTablesSource ||
      isLookupString ||
      isLookupNumber ||
      isLookupDate
    ) {
      const { type } = formData.toJS()

      if (type === TYPE_INPUT_TEXT && !isLookupString) {
        setIsLookupString(true)

        return
      }

      if (type === TYPE_INPUT_NUMBER && !isLookupNumber) {
        setIsLookupNumber(true)

        return
      }

      if (type === TYPE_INPUT_DATE && !isLookupDate) {
        setIsLookupDate(true)

        return
      }

      fetchLookupTablesSource()
    }
  }, [parameterValue, isLookupString, isLookupNumber, isLookupDate])

  useEffect(() => {
    if (jobWorkflows.size && search && search.length) {
      const queryParams = new URLSearchParams(search)
      const selectedJob = jobWorkflows.find(
        ({ title }) => title === queryParams.get('jobTitle'),
      )

      if (selectedJob) {
        setFormState(prevState => ({
          ...prevState,
          workflow: selectedJob.id,
        }))
        setJobWorkflow(selectedJob.id)

        if (jobWorkflowTasks.size) {
          const selectedTask = jobWorkflowTasks.find(
            ({ title }) => title === queryParams.get('taskTitle'),
          )

          if (selectedTask) {
            setFormState(prevState => ({
              ...prevState,
              task: selectedTask.id,
            }))
            setJobTask(selectedTask.id)

            if (jobWorkflowInputGroups.size) {
              const selectedInputGroup = jobWorkflowInputGroups.find(
                ({ title }) => title === queryParams.get('inputGroupTitle'),
              )

              if (selectedInputGroup) {
                setFormState(prevState => ({
                  ...prevState,
                  input_group: selectedInputGroup.id,
                }))
                setInputGroup(selectedInputGroup.id)
              }
            }
          }
        }
      }
    }
  }, [jobWorkflows, jobWorkflowTasks, jobWorkflowInputGroups, search])

  const [imagePath, setImagePath] = useState('')

  // eslint-disable-next-line max-statements
  useEffect(() => {
    if (formData.size) {
      const {
        title,
        type,
        position,
        enabled,
        required,
        task: { id: taskId },
        workflow: { id: workflowId },
        input_group,
        job_preview,
        task_preview,
        short_name,
        instructions,
        image_path,
        youtube_video_link,
        parameters: {
          [PARAMETER_LOOKUP_TABLES_SOURCE]: {
            conditions: conditionsParameter,
            creates_lookup_object,
            equal_to_site_name,
          } = {},
          display_options,
          can_set_current_datetime,
        },
      } = formData.toJS()

      const {
        range,
        options,
        options_source,
        images,
        lookup_table_source,
      } = formDataParams
      let inputGroupId
      let formattedFormDataParams

      setImagePath(image_path)

      if (input_group) {
        inputGroupId = input_group.id
      }

      setJobWorkflow(workflowId)
      setJobTask(taskId)
      setInputGroup(inputGroupId)

      if (range && range.length) {
        formattedFormDataParams = {
          ...formDataParams,
          minRange: range[0],
          maxRange: range[1],
        }
      }

      if (options) {
        setParameterValue(PARAMETER_OPTIONS)
        setDynamicOption(options)
      }

      if (options_source) {
        setParameterValue(PARAMETER_OPTIONS_SOURCE)

        if (options_source === PARAMETER_IMAGES) {
          const imagesList = images.map(({ path, title, description }) => ({
            path,
            title,
            description,
          }))

          setParameterValue(PARAMETER_IMAGES)
          setDynamicImages(imagesList)
        }
      }

      if (lookup_table_source) {
        setParameterValue(PARAMETER_LOOKUP_TABLES_SOURCE)
        if (conditionsParameter && conditionsParameter.length) {
          setDisplayConditions(true)
        }

        if (creates_lookup_object) {
          setIsCreatesNewRowChecked(creates_lookup_object)

          formattedFormDataParams = {
            ...formDataParams,
            [PARAMETER_LOOKUP_TABLES_SOURCE]: {
              ...formDataParams[PARAMETER_LOOKUP_TABLES_SOURCE],
              editable: creates_lookup_object,
            },
          }
        }
      }

      if (display_options) {
        setSelectDisplayType(display_options)
      }
      if (conditionsParameter && conditionsParameter.length) {
        const conditionsParameterForRender = conditionsParameter.map(
          condition => {
            const inputs = condition.inputs.join(',')

            return { ...condition, inputs }
          },
        )

        formattedFormDataParams = {
          ...formDataParams,
          [PARAMETER_LOOKUP_TABLES_SOURCE]: {
            ...formDataParams[PARAMETER_LOOKUP_TABLES_SOURCE],
            conditions: conditionsParameterForRender,
          },
        }
      }
      setEqualToSiteName(equal_to_site_name)
      setCanSetCurrentDatetime(can_set_current_datetime)
      setInputType(type)
      setEnTitle(title.en)
      setFormState(prevState => ({
        ...prevState,
        title,
        type,
        position,
        enabled,
        required,
        task: taskId,
        workflow: workflowId,
        input_group: inputGroupId,
        job_preview,
        task_preview,
        short_name,
        instructions,
        image_path,
        youtube_video_link,
        parameters: formattedFormDataParams || formDataParams,
      }))
    }
  }, [formData])

  useEffect(() => {
    const inputLookupTablesSourceData = inputLookupTablesSource.toJS()

    if (inputLookupTablesSourceData.length && formData.size) {
      const {
        parameters: {
          [PARAMETER_LOOKUP_TABLES_SOURCE]: { table: tableId, column } = {},
        },
        id: inputId,
      } = formData.toJS()
      const { columns } =
        inputLookupTablesSourceData.find(({ id }) => id === tableId) || {}

      if (columns) {
        const activeColumn = columns.find(({ key }) => key === column)

        setActiveLookupTable(tableId)
        setActiveLookupTableColumn(activeColumn)
        setActiveLookupTableColumnList(columns)
        fetchLookupConditions({
          tableId,
          jobTask,
          inputGroup,
          currentInput: inputId,
        })
      }
    }
  }, [inputLookupTablesSource])

  useEffect(() => {
    if (inputGroup && activeLookupTable) {
      let inputId

      if (formData.size) {
        const { id } = formData.toJS()

        inputId = id
      }

      fetchAllowedLookupColumns({
        tableId: activeLookupTable,
        inputGroup,
        currentInput: inputId,
      })
    }
  }, [inputGroup, activeLookupTable])

  const [imageData, setImageData] = useState({})

  useEffect(() => {
    if (Object.keys(imageData).length) {
      setImagePath(imageData.path)
    }
  }, [imageData])

  const isEnglish = value => value === 'en'

  const onChangeFile = file => {
    if (!file) return

    const fileForm = new FormData()
    fileForm.append('file', file[0])

    withPromise(uploadFiles, {
      file: fileForm,
      partUrl: MY_JOBS_UPLOAD_FILES,
      formatMessage,
    }).then(response => {
      if (response.error) {
        showNotice({
          notice: NoticeHelper.createErrorObj(
            formatMessage(messages.fileNotUploadMessage),
          ),
        })
      } else {
        setImageData(prevState => ({
          ...prevState,
          ...response,
        }))
      }
    })
  }

  const removeImage = () => {
    setImageData({})
    setImagePath('')
    onChangeFile(null)
  }

  const onTagInputChange = useCallback((value, handlers) => {
    handlers.handleSetDynamicValue('parameters.formula', value)
  }, [])

  const formatFormula = formula =>
    decodeURI(
      encodeURI(formula).replaceAll('%C2%A0', '').replaceAll('%E2%80%8B', ''),
    )

  const updateSelectOptions = option => {
    Object.values(APP_LANGUAGES).forEach(({ key }) => {
      const newOption = option

      if (!option[key]) {
        newOption[key] = option.en
      }
    })
  }

  const updateLookupParameters = (parameters, newParameters) => ({
    ...newParameters,
    [PARAMETER_LOOKUP_TABLES_SOURCE]: {
      ...parameters[PARAMETER_LOOKUP_TABLES_SOURCE],
      editable:
        !parameters[PARAMETER_LOOKUP_TABLES_SOURCE].creates_lookup_object &&
        parameters[PARAMETER_LOOKUP_TABLES_SOURCE].conditions &&
        parameters[PARAMETER_LOOKUP_TABLES_SOURCE].conditions[0]?.type ===
          LOOKUP_DISPLAY_TYPE
          ? !!parameters[PARAMETER_LOOKUP_TABLES_SOURCE].editable
          : undefined,
      creates_lookup_object:
        parameters[PARAMETER_LOOKUP_TABLES_SOURCE].creates_lookup_object ||
        undefined,
    },
    [PARAMETER_DEPENDENCY]: undefined,
  })

  // eslint-disable-next-line max-statements
  const handleSubmitForm = ({ type, ...restValues }) => {
    const valueObj = { ...restValues }
    const { parameters } = valueObj
    let formattedValueObj
    const displayOption = isParameterImages ? 'list' : selectDisplayType

    if (!getEntityId()) {
      valueObj.type = type
    }

    if (
      valueObj?.type === TYPE_INPUT_TEXT &&
      parameters &&
      parameters[PARAMETER_LOOKUP_TABLES_SOURCE] &&
      !parameters[PARAMETER_LOOKUP_TABLES_SOURCE].creates_lookup_object &&
      !parameters[PARAMETER_LOOKUP_TABLES_SOURCE]?.conditions?.length
    ) {
      return
    }

    if (isStringInput) {
      if (isLookupString) {
        const strParams = [
          PARAMETER_BARCODE,
          PARAMETER_MIN_LENGTH,
          PARAMETER_MAX_LENGTH,
          PARAMETER_NUMBERS_ONLY,
          PARAMETER_LONGTEXT,
        ]
        const newParameters = removeUnnecessaryProps(parameters, strParams)
        formattedValueObj = {
          ...valueObj,
          parameters: updateLookupParameters(newParameters, newParameters),
        }
      } else {
        formattedValueObj = {
          ...valueObj,
          parameters: removeUnnecessaryProps(parameters, [
            PARAMETER_LOOKUP_TABLES_SOURCE,
          ]),
        }
      }
    }

    if (inputType === TYPE_SELECT) {
      const normalizeSelectAllParameter = parameterValues => ({
        ...parameterValues,
        [PARAMETER_SELECT_ALL]: parameterValues?.[PARAMETER_MULTIPLE]
          ? !!parameterValues?.[PARAMETER_SELECT_ALL]
          : undefined,
      })
      let helperText

      if (isParameterOptions) {
        const { parameters: { options } = {} } = valueObj

        if (!options) {
          valueObj.parameters = {}
          valueObj.parameters.options = []
        }

        Object.values(options || []).forEach(option => {
          updateSelectOptions(option)
        })
      }

      if (isParameterImages) {
        if (formattedValueObj && formattedValueObj.parameters.images) {
          const isInvalid = formattedValueObj.parameters.images.some(
            image => !image.title.en || !image.description.en,
          )

          if (isInvalid) {
            return
          }

          formattedValueObj.parameters.images.forEach(image => {
            Object.values(APP_LANGUAGES).forEach(({ key }) => {
              const newImage = image

              if (!image.title[key]) {
                newImage.title[key] = image.title.en
              }

              if (!image.description[key]) {
                newImage.description[key] = image.description.en
              }
            })
          })
        } else if (valueObj && valueObj.parameters.images) {
          const isInvalid = valueObj.parameters.images.some(
            image => !image.title.en || !image.description.en,
          )

          if (isInvalid) {
            return
          }

          valueObj.parameters.images.forEach(image => {
            Object.values(APP_LANGUAGES).forEach(({ key }) => {
              const newImage = image

              if (!image.title[key]) {
                newImage.title[key] = image.title.en
              }

              if (!image.description[key]) {
                newImage.description[key] = image.description.en
              }
            })
          })
        }
      }

      if (formattedValueObj) {
        formattedValueObj = {
          ...valueObj,
          parameters: {
            ...normalizeSelectAllParameter(parameters),
            display_options: displayOption,
          },
        }
      } else {
        valueObj.parameters.display_options = displayOption
        valueObj.parameters = normalizeSelectAllParameter(valueObj.parameters)
      }

      if (!parameterValue) {
        helperText = formatMessage(messages.paramsSelectHint)
      }

      if (
        parameterValue &&
        isParameterOptions &&
        !dynamicOptions.filter(option => option).length
      ) {
        helperText = formatMessage(messages.dynamicEntryHint, {
          entry: formatMessage(messages.option),
        })
      }

      if (
        parameterValue &&
        isParameterImages &&
        !dynamicImages.filter(image => image.path).length
      ) {
        helperText = formatMessage(messages.dynamicEntryHint, {
          entry: formatMessage(messages.image),
        })
      }

      if (helperText && helperText.length) {
        showNotice({
          notice: NoticeHelper.createErrorObj(helperText),
        })

        return
      }

      if (!isParameterOptions) {
        const normalizedParameters = normalizeSelectAllParameter(parameters)
        formattedValueObj = {
          ...valueObj,
          parameters: removeUnnecessaryProps(normalizedParameters, [
            PARAMETER_DYNAMIC_OPTIONS_ALLOWED,
          ]),
        }
      }

      if (isParameterLookupTablesSource) {
        const normalizedParameters = normalizeSelectAllParameter(parameters)
        formattedValueObj = {
          ...valueObj,
          parameters: {
            ...normalizedParameters,
            [PARAMETER_LOOKUP_TABLES_SOURCE]: {
              ...normalizedParameters[PARAMETER_LOOKUP_TABLES_SOURCE],
              creates_lookup_object:
                normalizedParameters[PARAMETER_LOOKUP_TABLES_SOURCE]
                  .creates_lookup_object || undefined,
              unique: !normalizedParameters[PARAMETER_LOOKUP_TABLES_SOURCE]
                .equal_to_site_name
                ? !!normalizedParameters[PARAMETER_LOOKUP_TABLES_SOURCE].unique
                : undefined,
              editable: undefined,
              equal_to_site_name: !!normalizedParameters[
                PARAMETER_LOOKUP_TABLES_SOURCE
              ].equal_to_site_name,
              conditions: normalizedParameters[PARAMETER_LOOKUP_TABLES_SOURCE]
                ?.conditions?.length
                ? normalizedParameters[PARAMETER_LOOKUP_TABLES_SOURCE]
                    ?.conditions
                : undefined,
              condition: undefined,
            },
            display_options: 'dropdown',
          },
        }
      }
    }

    if (inputType === TYPE_INPUT_NUMBER) {
      if (parameters) {
        let newParameters = { ...parameters }

        if (Object.prototype.hasOwnProperty.call(parameters, 'range')) {
          const { range, minRange, maxRange } = parameters
          const rangesNotEmpty =
            minRange &&
            maxRange &&
            !isEmpty(minRange.toString() && maxRange.toString())
          const formattedValue = rangesNotEmpty && [+minRange, +maxRange]
          let removeParamKeys = ['minRange', 'maxRange']

          if (!rangesNotEmpty) {
            removeParamKeys = [...removeParamKeys, 'restrictive', 'range']
          } else if (isEmpty(range)) {
            newParameters = {
              ...newParameters,
              range: formattedValue,
            }
          }

          newParameters = removeUnnecessaryProps(newParameters, removeParamKeys)
        }

        if (
          Object.prototype.hasOwnProperty.call(parameters, PARAMETER_DECIMALS)
        ) {
          newParameters = {
            ...newParameters,
            decimals:
              parameters.decimals === '' ? undefined : parameters.decimals,
          }
        }

        if (isLookupNumber) {
          newParameters = updateLookupParameters(parameters, newParameters)
        } else {
          newParameters = {
            ...newParameters,
            [PARAMETER_LOOKUP_TABLES_SOURCE]: undefined,
          }
        }

        formattedValueObj = {
          ...valueObj,
          parameters: newParameters,
        }
      }
    }

    if (inputType === TYPE_INPUT_DATE || inputType === TYPE_INPUT_DATE_TIME) {
      if (parameters) {
        let newParameters = { ...parameters }

        if (isLookupDate) {
          newParameters = updateLookupParameters(parameters, newParameters)
        } else {
          newParameters = {
            ...newParameters,
            [PARAMETER_LOOKUP_TABLES_SOURCE]: undefined,
          }
        }

        formattedValueObj = {
          ...valueObj,
          parameters: newParameters,
        }
      }
    }

    if (inputType === TYPE_INPUT_CALCULATED) {
      const newParameters = {
        ...parameters,
        decimals: parameters.decimals || 0,
        editable: !!parameters.editable,
        formula: formatFormula(parameters.formula),
      }

      formattedValueObj = {
        ...valueObj,
        parameters: newParameters,
      }
    }

    if (inputType === TYPE_INPUT_TIME) {
      formattedValueObj = {
        ...valueObj,
        parameters: {
          ...valueObj.parameters,
          unchangeable_time:
            valueObj.parameters && !!valueObj.parameters.unchangeable_time,
        },
      }
    }

    Object.values(APP_LANGUAGES).forEach(({ key }) => {
      if (formattedValueObj) {
        if (!formattedValueObj.title[key]) {
          formattedValueObj.title[key] = formattedValueObj.title.en
        }
      } else if (!valueObj.title[key]) {
        valueObj.title[key] = valueObj.title.en
      }
    })

    Object.values(APP_LANGUAGES).forEach(({ key }) => {
      if (formattedValueObj && formattedValueObj.instructions) {
        if (
          !formattedValueObj.instructions[key] &&
          formattedValueObj.instructions.en
        ) {
          formattedValueObj.instructions[key] =
            formattedValueObj.instructions.en
        }
      } else if (valueObj && !valueObj.instructions[key]) {
        if (valueObj.instructions.en) {
          valueObj.instructions[key] = valueObj.instructions.en
        }
      }
    })

    if (formattedValueObj) {
      formattedValueObj.image_path = imagePath

      if (
        formattedValueObj.instructions &&
        !formattedValueObj.instructions.en
      ) {
        formattedValueObj.instructions = undefined
      }
    } else {
      valueObj.image_path = imagePath

      if (valueObj.instructions && !valueObj.instructions.en) {
        valueObj.instructions = undefined
      }
    }

    if (parameters[PARAMETER_LOOKUP_TABLES_SOURCE]?.conditions?.length) {
      const formattedParameters = formattedValueObj?.parameters || parameters
      formattedValueObj = {
        ...valueObj,
        parameters: {
          ...formattedParameters,
          [PARAMETER_LOOKUP_TABLES_SOURCE]: {
            ...formattedParameters[PARAMETER_LOOKUP_TABLES_SOURCE],
            conditions: parameters[PARAMETER_LOOKUP_TABLES_SOURCE]?.conditions
              ?.length
              ? parameters[PARAMETER_LOOKUP_TABLES_SOURCE]?.conditions.map(
                  condition => ({
                    inputs: condition.inputs?.split(',').map(Number),
                    type: condition.type,
                  }),
                )
              : [],
          },
        },
      }
    }

    return withPromise(saveJobInputsInfo, {
      entityId: getEntityId(),
      data: formattedValueObj || valueObj,
    }).then(errors => {
      if (errors) {
        return Promise.resolve(errors)
      }

      setRedirect(true)
    })
  }

  const handleFileUpload = (
    fileIndex,
    {
      currentTarget: {
        files: [file],
      },
    },
    formCallback,
  ) => {
    if (!file) {
      return false
    }

    const fileForm = new FormData()
    fileForm.append('file', file)

    withPromise(uploadFiles, {
      file: fileForm,
      partUrl: MY_JOBS_UPLOAD_FILES,
      formatMessage,
    }).then(response => {
      if (response.error) {
        showNotice({
          notice: NoticeHelper.createErrorObj(
            formatMessage(messages.fileNotUploadMessage),
          ),
        })
      } else {
        const updatedImages = dynamicImages.map((value, index) => {
          if (index === fileIndex) {
            return {
              path: response.path,
              title: '',
              description: '',
            }
          }

          return value
        })

        formCallback(updatedImages.filter(item => item.path))
        setDynamicImages(updatedImages)
      }
    })
  }

  const handleArrayValue = value => {
    const floatNumbersRegExp = /^\d+[.,]?(\d+)?$/

    if (new RegExp(floatNumbersRegExp).test(value)) {
      return value
    }
  }

  const getFormField = (
    { value, title, required, type },
    disabled,
    customHandler = undefined,
  ) => {
    let formField = null
    const validators = []

    if (required) {
      validators.push(VALIDATOR_IS_EMPTY)
    }

    if (
      value === PARAMETER_DECIMALS ||
      value === PARAMETER_MAX_LENGTH ||
      value === PARAMETER_MIN_LENGTH
    ) {
      validators.push(VALIDATOR_IS_POSITIVE_INTEGER)
    }

    if (value === PARAMETER_MAX_LENGTH || value === PARAMETER_MIN_LENGTH) {
      validators.push(VALIDATOR_IS_INVALID_RANGE)
    }

    if (type === TYPE_INPUT_BOOLEAN) {
      formField = (
        <div key={value} className="form-group">
          <FormControl
            required={required}
            disabled={disabled}
            onChange={customHandler}>
            <FormControlLabel
              label={title}
              className="form-label"
              control={
                <Field
                  name={`parameters.${value}`}
                  component={Checkbox}
                  type="checkbox"
                  color="primary"
                />
              }
            />
          </FormControl>
        </div>
      )
    }

    if (type === TYPE_INPUT_NUMBER) {
      formField = (
        <Field
          key={value}
          name={`parameters.${value}`}
          type="number"
          label={title}
          component={Input}
          required={required}
          disabled={disabled}
          parse={value => {
            if (value === '') {
              return value
            }

            if (Number.isNaN(+value)) {
              const prevValue = value.slice(0, -1)

              return prevValue.length ? +prevValue : prevValue
            }

            return +value
          }}
          validate={getValidator(validators)}
        />
      )
    }

    if (type === TYPE_INPUT_TEXT) {
      formField = (
        <Field
          key={value}
          name={`parameters.${value}`}
          type="text"
          label={title}
          component={Input}
          required={required}
          disabled={disabled}
          validate={getValidator(validators)}
        />
      )
    }

    return formField
  }

  const renderIsLookupInputCheckbox = (
    isLookupInput,
    setIsLookupInput,
    handler,
    submitting,
  ) => (
    <FormControlLabel
      label={formatMessage(messages.lookupInput)}
      control={
        <CheckboxComponent
          checked={isLookupInput}
          color="primary"
          disabled={submitting}
          onClick={() => {
            setIsLookupInput(!isLookupInput)
            handler()
          }}
        />
      }
    />
  )

  const renderCustomTagListItem = (item, tagifySuggestionIdx) => `
    <div
        id="${item.id}"
        type"${item.type}"
        value="${item.value}"
        prefix="${item.prefix}"
        class="tagify__dropdown__item"
        tabindex="${tagifySuggestionIdx}"
        role="option"
        tagifySuggestionIdx="${tagifySuggestionIdx}"
    >
        ${item.value}
    </div>
  `

  const renderCustomTagInputDropdown = (settings, suggestions, _this) => {
    let customDropdownHTML = ''
    let tagifySuggestionIdx = 0
    const inputList = suggestions.filter(({ type }) => type === 'input')
    const outputList = suggestions.filter(({ type }) => type === 'output')

    if (inputList.length) {
      customDropdownHTML += `<div class='tagify__dropdown__title'>${formatMessage(
        messages.inputs,
      )}</div>`

      inputList.forEach(item => {
        customDropdownHTML += renderCustomTagListItem(item, tagifySuggestionIdx)

        tagifySuggestionIdx += 1
      })
    }

    if (outputList.length) {
      customDropdownHTML += `<div class='tagify__dropdown__title'>${formatMessage(
        messages.outputs,
      )}</div>`

      outputList.forEach(item => {
        customDropdownHTML += renderCustomTagListItem(item, tagifySuggestionIdx)

        tagifySuggestionIdx += 1
      })
    }

    return `
            ${settings.templates.dropdownHeader.call(_this, suggestions)}
            ${customDropdownHTML}
            ${settings.templates.dropdownFooter.call(_this, suggestions)}
        `
  }

  /* eslint-disable max-statements */
  /**
   * @returns {Element}
   */
  const getDynamicField = (
    handlers,
    submitting,
    disableTrigger,
    values,
    isEmptyCondition,
  ) => {
    const booleanTypes = parameters.filter(
      item => item.type === TYPE_INPUT_BOOLEAN,
    )
    const conditions =
      values?.parameters?.[PARAMETER_LOOKUP_TABLES_SOURCE]?.conditions ?? []
    const isConditionsNotDisplay = conditions?.some(
      condition => condition.type !== 'display',
    )

    const isCreatesLookupObjectCheckboxDisabled =
      submitting ||
      isConditionsNotDisplay ||
      !inputGroup ||
      !activeLookupTableColumnList.length

    const handleOptionAdd = () =>
      setDynamicOption([...dynamicOptions, langFields])

    const handleOptionChange = (index, e, key) => {
      const updatedValues = dynamicOptions.map((value, optionIndex) => {
        if (optionIndex === index) {
          return { ...value, [key]: e.target.value }
        }

        return value
      })

      handlers.handleParametersOptionsSet(updatedValues.filter(item => item))
      setDynamicOption(updatedValues)
    }

    const handleOptionClear = (index, key) => {
      const updatedValues = dynamicOptions.map((value, optionIndex) => {
        if (optionIndex === index) {
          return { ...value, [key]: '' }
        }

        return value
      })

      handlers.handleParametersOptionsSet(updatedValues.filter(item => item))
      setDynamicOption(updatedValues)
    }

    const handleOptionDelete = (index, value) => {
      const filteredOptions = dynamicOptions.filter(
        (item, optionIndex) => optionIndex !== index && item !== value,
      )

      setDynamicOption(filteredOptions)
      handlers.handleSetDynamicValue('parameters.options', filteredOptions)
    }

    const handleSelectChange = ({ index }) => {
      setParameterValue(index)
      setDynamicImages([
        {
          path: '',
          title: langFields,
          description: langFields,
        },
      ])
      handlers.handleOptionsClear()

      if (index === PARAMETER_IMAGES) {
        handlers.handleSetDynamicValue(
          'parameters.options_source',
          PARAMETER_IMAGES,
        )
        setSelectDisplayType('list')
      }
    }

    const getRangeValue = (name, value) => {
      const {
        parameters: { range = [] },
      } = formState
      const itemIndex = name === 'parameters.minRange' ? 0 : -1

      if (!isEmpty(range)) {
        range.splice(itemIndex, 1, value)
      }

      return range
    }

    const handleRangeChange = ({ target: { value, name } }) => {
      const verifiedValue = handleArrayValue(value) || ''
      const rangeValue = getRangeValue(name, verifiedValue)

      handlers.handleSetDynamicValue('parameters.range', rangeValue)
    }

    const formatRangeValue = ({ target: { value, name } }) => {
      let formattedValue = value.replace(/[.,]$/, '')

      if (value && typeof value === 'string' && value.includes(',')) {
        formattedValue = formattedValue.replace(/[,]/g, '.')
      }
      const resultValue = getRangeValue(name, formattedValue)
      const typedValue = resultValue.map(i => i && Number(i))

      handlers.handleSetDynamicValue('parameters.range', typedValue)
    }

    const handleImageAdd = () => {
      setDynamicImages([
        ...dynamicImages,
        {
          path: '',
          title: langFields,
          description: langFields,
        },
      ])
    }

    const handleImageDelete = (index, imagePath) => {
      const filteredImages = dynamicImages.filter(
        (item, imageIndex) => index !== imageIndex && item.path !== imagePath,
      )

      setDynamicImages(filteredImages)
      handlers.handleImagesChange(filteredImages)
    }

    const handleImageTextFieldChange = (index, event, mainField) => {
      const {
        target: { value },
        currentTarget: {
          dataset: { field },
        },
      } = event

      const updatedImages = dynamicImages.map((imageData, imageIndex) => {
        if (imageIndex === index) {
          return {
            ...imageData,
            [mainField]: { ...imageData[mainField], [field]: value },
          }
        }

        return imageData
      })

      handlers.handleSetDynamicValue('parameters.images', updatedImages)
      setDynamicImages(updatedImages)
    }

    const handleImageTextFieldClear = (index, key, mainField) => {
      const updatedImages = dynamicImages.map((imageData, imageIndex) => {
        if (imageIndex === index) {
          return {
            ...imageData,
            [mainField]: { ...imageData[mainField], [key]: '' },
          }
        }

        return imageData
      })

      handlers.handleSetDynamicValue('parameters.images', updatedImages)
      setDynamicImages(updatedImages)
    }

    const handleBarcodeChange = ({ target: { checked } }) => {
      if (checked) {
        handlers.handleStringParametersClear()
      }
    }

    const handleNumbersOnlyChange = ({ target: { checked } }) => {
      if (checked) {
        handlers.handleSetDynamicValue('parameters.barcode', undefined)
        handlers.handleSetDynamicValue('parameters.longtext', undefined)
      }
    }

    const renderConditionTypeSelect = (
      conditionSection,
      conditionTypesList,
      index,
    ) => (
      <div className="lookup-type-section">
        {conditionTypesList.map(type => (
          <div // eslint-disable-line jsx-a11y/no-static-element-interactions
            key={type}
            className="lookup-type-radio"
            onClick={() => {
              const newSection = { ...conditionSection, type }
              handlers.handleLookupWithTypeConditionChange(newSection, index)

              if (type !== LOOKUP_DISPLAY_TYPE) {
                handlers.handleLookupEditableClear()
              } else {
                handlers.handleLookupWithTypeEditableChange(editableDisabled)
              }
            }}>
            <Radio
              href={null}
              color="primary"
              checked={type === conditionSection.type}
            />
            {formatMessage(messages[type])}
          </div>
        ))}
      </div>
    )

    const renderLookupParameters = () => (
      <>
        <Field
          key={`${PARAMETER_LOOKUP_TABLES_SOURCE}.table`}
          name={`parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.table`}
          label={formatMessage(messages.fromTable)}
          component={SelectInput}
          disabled={submitting || !jobTask}
          onChange={(args, state, utils) => {
            const { columns } = inputLookupTablesSource.find(
              ({ id: tableId }) => tableId === args.target.value,
            )
            const inputId = formData.size ? formData.toJS().id : undefined

            setActiveLookupTableColumnList(columns)
            setActiveLookupTableColumn(null)
            setActiveLookupTable(args.target.value)
            handlers.handleLookupTablesSourceChange(args, state, utils)
            fetchLookupConditions({
              tableId: args.target.value,
              jobTask,
              inputGroup,
              currentInput: inputId,
            })
          }}
          validate={getValidator(VALIDATOR_IS_EMPTY)}>
          {inputLookupTablesSource.map(item => (
            <MenuItem button key={item.id} value={item.id}>
              {item.title}
            </MenuItem>
          ))}
        </Field>
        <Field
          key={`${PARAMETER_LOOKUP_TABLES_SOURCE}.column`}
          name={`parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.column`}
          label={formatMessage(messages.fromColumn)}
          component={SelectInput}
          disabled={submitting || !activeLookupTableColumnList.length}
          onChange={(args, state, utils) => {
            const activeColumn = activeLookupTableColumnList.find(
              ({ key }) => key === args.target.value,
            )

            setActiveLookupTableColumn(activeColumn)
            handlers.handleLookupTablesColumnChange(args, state, utils)
          }}
          validate={getValidator(VALIDATOR_IS_EMPTY)}>
          {activeLookupTableColumnList.map(item => {
            const isOptionDisabled =
              !allowedTableColumns
                .toJS()
                .find(columnId => columnId === item.key) &&
              !displayConditions &&
              isCreatesNewRowChecked

            return (
              <MenuItem
                button
                key={item.key}
                value={item.key}
                disabled={isOptionDisabled}>
                {item.title}
              </MenuItem>
            )
          })}
        </Field>
        {(inputType === TYPE_INPUT_TEXT || inputType === TYPE_SELECT) && (
          <FormControl
            className="form-group"
            key={`${PARAMETER_LOOKUP_TABLES_SOURCE}.${
              isStringInput ? 'editable' : 'unique'
            }`}
            required>
            <FormControlLabel
              label={
                isStringInput
                  ? formatMessage(messages.editable)
                  : formatMessage(messages.onlyUnique)
              }
              disabled={
                submitting ||
                (!isStringInput && equalToSiteName) ||
                isCreatesNewRowChecked
              }
              className="form-label"
              control={
                <Field
                  name={`parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.${
                    isStringInput ? 'editable' : 'unique'
                  }`}
                  defaultValue={false}
                  component={Checkbox}
                  type="checkbox"
                  color="primary"
                  disabled={submitting}
                />
              }
            />
          </FormControl>
        )}
        {inputType === TYPE_SELECT && (
          <Flex className="form-group" align="center">
            <FormControl
              key={`${PARAMETER_LOOKUP_TABLES_SOURCE}.equal_to_site_name`}
              onChange={handlers.handleEqualToSiteNameChange}>
              <FormControlLabel
                label={formatMessage(messages.equalToSiteName)}
                disabled={submitting}
                className="form-label"
                control={
                  <Field
                    name={`parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.equal_to_site_name`}
                    component={Checkbox}
                    type="checkbox"
                    color="primary"
                    disabled={submitting}
                  />
                }
              />
            </FormControl>
            <Tooltip
              title={formatMessage(messages.equalToSiteNameTooltip)}
              placement="top">
              <StyledQuestionIcon />
            </Tooltip>
          </Flex>
        )}
      </>
    )

    const renderAddConditionButton = type => (
      <MaterialButton
        onClick={() => {
          handlers.handlerAddNewLookupCondition(type)
        }}
        className="add-button">
        + {formatMessage(messages.addCondition)}
      </MaterialButton>
    )

    const renderAddConditionsButton = () => (
      <MaterialButton
        onClick={() => {
          setDisplayConditions(true)
        }}
        className="add-button">
        + {formatMessage(messages.addConditions)}
      </MaterialButton>
    )

    const renderCreatesLookupObjectCheckbox = () => (
      <FormControl>
        <FormControlLabel
          label={formatMessage(messages.createsNewRowInTheTable)}
          disabled={submitting || isCreatesLookupObjectCheckboxDisabled}
          className="form-label custom-checkbox-label"
          onClick={event => {
            if (!submitting && !isCreatesLookupObjectCheckboxDisabled) {
              event.stopPropagation()
              event.preventDefault()
              handlers.handleCreatesNewRowInTheTableChange(
                !isCreatesNewRowChecked,
              )
            }
          }}
          control={
            <Field
              name={`parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.creates_lookup_object`}
              component={CheckboxInput}
              type="checkbox"
              color="primary"
              disabled={submitting || isCreatesLookupObjectCheckboxDisabled}
              validate={
                !displayConditions &&
                inputType !== TYPE_SELECT &&
                !isCreatesLookupObjectCheckboxDisabled
                  ? getValidator(VALIDATOR_IS_EMPTY)
                  : undefined
              }
            />
          }
        />
      </FormControl>
    )

    const renderLookupConditions = () => (
      <>
        <div
          className={cn('form-group conditions-section', {
            hide: !displayConditions,
          })}>
          <Typography gutterBottom variant="h6">
            {formatMessage(messages.conditions)}
          </Typography>
          {conditions.map((condition, index) => (
            <div key={`condition-${index}`} className="condition-block">
              <Field
                name={`parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions[${index}].inputs`}
                label={formatMessage(messages.lookupInput)}
                component={SelectInput}
                disabled={submitting || !inputLookupConditions.size}
                onChange={handlers.handleLookupConditionChange}
                required={displayConditions}
                validate={getValidator(VALIDATOR_IS_EMPTY)}>
                {inputLookupConditions.map(item => {
                  const value = item.ids.join(',')

                  return (
                    <MenuItem
                      button
                      key={`${index}-${value}`}
                      index={index}
                      value={value}>
                      {item.title}
                    </MenuItem>
                  )
                })}
              </Field>
              <IconButton
                size="small"
                onClick={() => handlers.handleLookupConditionClear(index)}
                className="btn-remove-input">
                <Tooltip title={formatMessage(messages.removeItem)}>
                  <IconDelete />
                </Tooltip>
              </IconButton>
            </div>
          ))}
          {renderAddConditionButton(LOOKUP_DISPLAY_TYPE)}
        </div>
        <div>{!displayConditions && renderAddConditionsButton()}</div>
        {renderCreatesLookupObjectCheckbox()}
      </>
    )

    const renderLookupWithTypeConditions = conditionTypesList => (
      <>
        <div
          className={cn('form-group conditions-section', {
            hide: !displayConditions,
          })}>
          <Typography gutterBottom variant="h6">
            {formatMessage(messages.conditions)}
          </Typography>
          {conditions.map((conditionSection, index) => (
            <>
              {renderConditionTypeSelect(
                conditionSection,
                conditionTypesList.filter(conditionType => {
                  if (index > 0 && conditionType === LOOKUP_DISPLAY_TYPE) {
                    return false
                  }

                  return true
                }),
                index,
              )}
              <div className="conditions-section-body">
                <Typography gutterBottom>
                  {formatMessage(messages[conditionSection.type])}{' '}
                  {formatMessage(messages.only)}
                  <span className="column-name">
                    {activeLookupTableColumn
                      ? activeLookupTableColumn.title
                      : formatMessage(messages.columnName)}
                  </span>
                  {formatMessage(messages.matchingValueIn)}
                </Typography>
                <div className="condition-block">
                  <Field
                    key={`${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions[${index}].inputs`}
                    name={`parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions[${index}].inputs`}
                    label={formatMessage(messages.lookupInput)}
                    component={SelectInput}
                    disabled={submitting || !inputLookupConditions.size}
                    onChange={({ target: { value } }) => {
                      const newSection = { ...conditionSection, inputs: value }

                      handlers.handleLookupWithTypeConditionChange(
                        newSection,
                        index,
                      )
                    }}
                    required={displayConditions}
                    validate={
                      displayConditions && inputType !== TYPE_SELECT
                        ? getValidator(VALIDATOR_IS_EMPTY)
                        : undefined
                    }>
                    {inputLookupConditions.map(item => {
                      const value = item.ids.join(',')

                      return (
                        <MenuItem
                          button
                          key={`${index}-${value}`}
                          value={value}
                          index={index}>
                          {item.title}
                        </MenuItem>
                      )
                    })}
                  </Field>
                  <IconButton
                    size="small"
                    onClick={() => handlers.handleLookupConditionClear(index)}
                    className="btn-remove-input">
                    <Tooltip title={formatMessage(messages.removeItem)}>
                      <IconDelete />
                    </Tooltip>
                  </IconButton>
                </div>
                {conditionSection.type === 'subtract' &&
                  featureFlags.NEGATIVE_LOOKUP_INVENTORY &&
                  inputType === TYPE_INPUT_NUMBER && (
                    <FormControl
                      className="validation-checkbox"
                      key={`${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions[${index}].validation.type`}>
                      <FormControlLabel
                        label={formatMessage(
                          messages.negativeValidationCheckbox,
                        )}
                        disabled={submitting}
                        className="form-label"
                        control={
                          <Field
                            name={`parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions[${index}].validation.type`}
                            component={Checkbox}
                            type="checkbox"
                            color="primary"
                            disabled={submitting}
                            parse={val => (val ? 'not-negative' : null)}
                          />
                        }
                      />
                    </FormControl>
                  )}
                {conditionSection.type === LOOKUP_DISPLAY_TYPE &&
                  !isStringInput && (
                    <FormControl
                      className="editable-option"
                      key={`${PARAMETER_LOOKUP_TABLES_SOURCE}.editable`}>
                      <FormControlLabel
                        label={formatMessage(messages.editable)}
                        disabled={submitting || editableDisabled}
                        className="form-label"
                        control={
                          <Field
                            name={`parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.editable`}
                            component={Checkbox}
                            type="checkbox"
                            color="primary"
                            disabled={submitting || editableDisabled}
                          />
                        }
                      />
                    </FormControl>
                  )}
              </div>
            </>
          ))}
          {renderAddConditionButton(
            conditions.length > 0 ? LOOKUP_UPDATE_TYPE : LOOKUP_DISPLAY_TYPE,
          )}
        </div>
        {isEmptyCondition && (
          <InvalidEmptyValue>
            {formatMessage({ id: 'invalid_empty_value' })}
          </InvalidEmptyValue>
        )}
        <div>{!displayConditions && renderAddConditionsButton()}</div>
        {renderCreatesLookupObjectCheckbox()}
      </>
    )

    const renderNumberParameters = () =>
      parameters.map(field => {
        const { type, title, value, required } = field
        if (value === PARAMETER_LOOKUP_TABLES_SOURCE && !hasEntityId) {
          return renderIsLookupInputCheckbox(
            isLookupNumber,
            setIsLookupNumber,
            handlers.handleLookupWithTypeConditionClear,
            submitting,
          )
        }

        if (type === TYPE_ARRAY && value === 'range') {
          return (
            <FormControl
              key={value}
              required={required}
              disabled={submitting}
              className="job-field-main-box"
              onChange={handleRangeChange}
              onBlur={formatRangeValue}>
              <span className="job-field-label">
                {formatMessage({ id: title })}{' '}
              </span>
              <Field
                key="minRange"
                name="parameters.minRange"
                type="text"
                component={Input}
                validate={getValidator(VALIDATOR_IS_INVALID_RANGE)}
              />
              <Field
                key="maxRange"
                name="parameters.maxRange"
                type="text"
                component={Input}
                validate={getValidator(VALIDATOR_IS_INVALID_RANGE)}
              />
            </FormControl>
          )
        }

        if (value === TYPE_FORMULA) {
          const { formula = '' } = formDataParams

          if (!isNumberInputsLoaded) {
            return null
          }

          return (
            <FormControl
              key={value}
              required={required}
              disabled={submitting}
              className="job-field-formula-box">
              <span className="label">
                {enTitle ? `${enTitle} =` : formatMessage({ id: title })}
              </span>
              <Tags
                tagifyRef={tagifyRef}
                placeholder={formatMessage(
                  messages.calculationInputPlaceholder,
                )}
                settings={{
                  mode: 'mix',
                  pattern: /#/,
                  enforceWhitelist: true,
                  duplicates: true,
                  dropdown: {
                    enabled: 0,
                    classname: 'tag-dropdown',
                    includeSelectedTags: true,
                    maxItems: 1000,
                  },
                  templates: {
                    dropdownContent() {
                      /* eslint-disable react/no-this-in-sfc */
                      const _s = this.settings
                      const {
                        dropdown: { suggestions },
                      } = this.state
                      /* eslint-enable react/no-this-in-sfc */

                      return renderCustomTagInputDropdown(_s, suggestions, this)
                    },
                  },
                }}
                whitelist={numberInputs}
                keepInvalidTags
                defaultValue={formula}
                onChange={({ detail: { value } }) => {
                  onTagInputChange(value, handlers)
                }}
              />
            </FormControl>
          )
        }

        return getFormField(field, submitting)
      })

    const renderSimpleStringParameters = () =>
      parameters.map(field => {
        const { type, value } = field
        let disableField = submitting

        if (type === TYPE_INPUT_BOOLEAN) {
          if (value === PARAMETER_BARCODE) {
            const barcodeDisabler =
              submitting || disableTrigger === PARAMETER_NUMBERS_ONLY

            return getFormField(field, barcodeDisabler, handleBarcodeChange)
          }

          if (value === PARAMETER_NUMBERS_ONLY) {
            const numbersDisabler =
              submitting || disableTrigger === PARAMETER_BARCODE

            return getFormField(field, numbersDisabler, handleNumbersOnlyChange)
          }

          if (value === PARAMETER_LONGTEXT) {
            const longtextDisabler = submitting || !!disableTrigger

            return getFormField(field, longtextDisabler)
          }
        }

        if (disableTrigger === PARAMETER_BARCODE) {
          disableField = submitting || !!disableTrigger
        }

        return getFormField(field, disableField)
      })

    const renderLookupWithTypeParameters = conditionTypesList => (
      <>
        {renderLookupParameters()}
        {renderLookupWithTypeConditions(conditionTypesList)}
      </>
    )

    if (inputType && inputType === TYPE_SELECT) {
      const result = []
      const isMultipleEnabled = !!values?.parameters?.[PARAMETER_MULTIPLE]
      const options = parameters.filter(
        item =>
          item.type !== TYPE_INPUT_BOOLEAN && item.value !== 'display_options',
      )

      result.push(
        ...booleanTypes
          .filter(item => {
            if (item.value === PARAMETER_DYNAMIC_OPTIONS_ALLOWED) {
              return isParameterOptions
            }

            if (item.value === PARAMETER_SELECT_ALL) {
              return isMultipleEnabled
            }

            return true
          })
          .map(item => {
            const isDisabled =
              item.value === 'dynamic_options' &&
              (selectDisplayType === 'list' ||
                selectDisplayType === 'horizontal_scroll')
            const handleMultipleChange = ({ target: { checked } }) => {
              if (!checked) {
                handlers.handleSetDynamicValue(
                  `parameters.${PARAMETER_SELECT_ALL}`,
                  false,
                )
              }
            }

            return (
              <div key={item.value} className="form-group">
                <FormControl
                  required={item.required}
                  disabled={submitting || isDisabled}
                  onChange={
                    item.value === PARAMETER_MULTIPLE
                      ? handleMultipleChange
                      : undefined
                  }>
                  <FormControlLabel
                    label={item.title}
                    className="form-label"
                    control={
                      <Field
                        name={`parameters.${item.value}`}
                        component={Checkbox}
                        type="checkbox"
                        color="primary"
                      />
                    }
                  />
                </FormControl>
              </div>
            )
          }),
      )

      if (!isParameterImages && !isParameterLookupTablesSource) {
        result.push(
          <div key="display-options" className="form-group">
            <span className="label">
              {formatMessage(messages.displayOptions)}
            </span>
            {DISPLAY_OPTIONS.map(option => (
              <div
                key={option}
                className="string-type-radio"
                onClick={() => {
                  if (option !== 'dropdown') {
                    handlers.handleSetDynamicValue(
                      'parameters.dynamic_options',
                      false,
                    )
                  }

                  setSelectDisplayType(option)
                }}>
                <Radio
                  href={null}
                  color="primary"
                  checked={selectDisplayType === option}
                />
                {formatMessage({ id: option })}
              </div>
            ))}
          </div>,
        )
      }

      result.push(
        <div key="select" className="form-group">
          <SelectList
            required
            label={formatMessage(messages.select)}
            onChange={handleSelectChange}
            list={List(options)}
            value={parameterValue}
            disabled={submitting || hasEntityId}
            map={{
              index: 'value',
              text: 'title',
            }}
          />
        </div>,
      )

      if (isParameterOptions) {
        const allOptions = dynamicOptions

        if (!Array.isArray(dynamicOptions)) {
          setDynamicOption(Object.values(dynamicOptions))

          return
        }

        allOptions.forEach((value, index) => {
          result.push(
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className={classes.options_item}>
              <TitleInput
                handleTitleClear={key => {
                  handleOptionClear(index, key)
                }}
                formState={value}>
                {Object.values(APP_LANGUAGES).map(({ key }) => {
                  const validators = [VALIDATOR_IS_LESS_THEN_255_SYMBOLS]

                  if (isEnglish(key)) {
                    validators.push(VALIDATOR_IS_EMPTY)
                  }

                  return (
                    <TextField
                      key={key}
                      lang={key}
                      type="text"
                      label={`${key} Value`}
                      validate={getValidator(validators)}
                      value={value[key]}
                      disabled={submitting}
                      className={classes.picture_option}
                      onChange={e => handleOptionChange(index, e, key)}
                    />
                  )
                })}
              </TitleInput>
              {index !== 0 && (
                <IconButton
                  size="small"
                  onClick={() => handleOptionDelete(index, value)}
                  className="btn-remove-input">
                  <Tooltip title={formatMessage(messages.removeItem)}>
                    <IconDelete />
                  </Tooltip>
                </IconButton>
              )}
            </div>,
          )
        })

        result.push([
          <Field
            key="options-field"
            name="parameters.options"
            type="hidden"
            component={() => null}
          />,
          <Button
            key="add_button"
            href={null}
            type="button"
            color="primary"
            size="small"
            variant="contained"
            onClick={handleOptionAdd}>
            <IconAdd />
          </Button>,
        ])
      }

      if (isParameterOptionSource) {
        result.push(
          <Field
            key="options_source"
            name="parameters.options_source"
            label={formatMessage(messages.optionsSource)}
            component={SelectInput}
            disabled={submitting}
            onChange={handlers.handleOptionsSourceChange}
            validate={getValidator(VALIDATOR_IS_EMPTY)}>
            {inputOptionsSource.map(item => (
              <MenuItem button key={item.value} value={item.value}>
                {item.title}
              </MenuItem>
            ))}
          </Field>,
        )
      }

      if (isParameterLookupTablesSource) {
        result.push(
          <>
            {renderLookupParameters()}
            {renderLookupConditions()}
          </>,
        )
      }

      if (isParameterImages) {
        dynamicImages.forEach((item, index) => {
          result.push(
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className="form-group">
              {!item.path ? (
                <InputLabel htmlFor="input-file">
                  <input
                    id="input-file"
                    className={classes.file_input}
                    type="file"
                    accept="image/jpg, image/jpeg, image/png"
                    onChange={event => {
                      handleFileUpload(
                        index,
                        event,
                        handlers.handleImagesChange,
                      )
                    }}
                  />
                  {!item.path && (
                    <div className={classes.field_input}>
                      <IconUploadFile className={classes.field_icon} />
                      {formatMessage(messages.uploadPngJpeg)}
                    </div>
                  )}
                </InputLabel>
              ) : (
                <div className={classes.field_image}>
                  <div className="field-image-box">
                    <TextField
                      required
                      fullWidth
                      readOnly
                      type="text"
                      label="Image"
                      className="form-group"
                      value={item.path}
                      disabled={submitting}
                    />
                    <FormControl fullWidth className="form-group">
                      <TitleInput
                        handleTitleClear={key => {
                          handleImageTextFieldClear(index, key, 'title')
                        }}
                        formState={item.title}>
                        {Object.values(APP_LANGUAGES).map(({ key }) => {
                          const isInvalid = isEnglish(key) && !item.title[key]

                          return (
                            <TextField
                              key={key}
                              lang={key}
                              isInvalid={isInvalid}
                              required={isEnglish(key)}
                              type="text"
                              className={
                                isInvalid
                                  ? classes.picture_option_invalid
                                  : classes.picture_option
                              }
                              inputProps={{
                                'data-field': key,
                              }}
                              label={`${key} ${formatMessage(messages.title)}`}
                              value={item.title[key]}
                              disabled={submitting}
                              onChange={event => {
                                handleImageTextFieldChange(
                                  index,
                                  event,
                                  'title',
                                )
                              }}
                            />
                          )
                        })}
                      </TitleInput>
                    </FormControl>
                    <TitleInput
                      handleTitleClear={key => {
                        handleImageTextFieldClear(index, key, 'description')
                      }}
                      formState={item.description}>
                      {Object.values(APP_LANGUAGES).map(({ key }) => {
                        const isInvalid =
                          isEnglish(key) && !item.description[key]

                        return (
                          <TextField
                            key={key}
                            required={isEnglish(key)}
                            isInvalid={isInvalid}
                            fullWidth
                            className={
                              isInvalid
                                ? classes.picture_option_invalid
                                : classes.picture_option
                            }
                            type="text"
                            lang={key}
                            inputProps={{
                              'data-field': key,
                            }}
                            label={`${key} ${formatMessage(
                              messages.description,
                            )}`}
                            value={item.description[key]}
                            disabled={submitting}
                            onChange={event => {
                              handleImageTextFieldChange(
                                index,
                                event,
                                'description',
                              )
                            }}
                          />
                        )
                      })}
                    </TitleInput>
                  </div>
                  <IconButton
                    size="small"
                    onClick={() => handleImageDelete(index, item.path)}
                    className="btn-remove-input">
                    <Tooltip title={formatMessage(messages.removeItem)}>
                      <IconDelete />
                    </Tooltip>
                  </IconButton>
                </div>
              )}
            </div>,
          )
        })

        result.push([
          <Field
            key="images-field"
            name="parameters.images"
            type="hidden"
            component={() => null}
          />,
          <Button
            key="add-image-button"
            href={null}
            type="button"
            color="primary"
            size="small"
            variant="contained"
            onClick={handleImageAdd}>
            <IconAdd />
          </Button>,
        ])
      }

      return result
    }

    if (inputType && isStringInput) {
      return (
        <>
          {!hasEntityId && (
            <div className="string-type-section">
              <div // eslint-disable-line jsx-a11y/no-static-element-interactions
                className="string-type-radio"
                onClick={() => {
                  if (isLookupString) {
                    setIsLookupString(!isLookupString)
                  }
                }}>
                <Radio href={null} color="primary" checked={!isLookupString} />
                {formatMessage(messages.simpleString)}
              </div>
              <div // eslint-disable-line jsx-a11y/no-static-element-interactions
                className="string-type-radio"
                onClick={() => {
                  if (!isLookupString) {
                    setIsLookupString(!isLookupString)
                    handlers.handleParametersClear({
                      [PARAMETER_LOOKUP_TABLES_SOURCE]: {
                        condition: { type: 'display', input: null },
                      },
                    })
                  }
                }}>
                <Radio href={null} color="primary" checked={isLookupString} />
                {formatMessage(messages.lookupString)}
              </div>
            </div>
          )}
          {isLookupString
            ? renderLookupWithTypeParameters(
                STRING_OR_DATE_INPUT_CONDITION_TYPES,
              )
            : renderSimpleStringParameters()}
        </>
      )
    }

    if (
      inputType &&
      (inputType === TYPE_INPUT_NUMBER || inputType === TYPE_INPUT_CALCULATED)
    ) {
      return (
        <>
          {renderNumberParameters()}
          {isLookupNumber &&
            renderLookupWithTypeParameters(NUMBER_INPUT_CONDITION_TYPES)}
        </>
      )
    }

    if (
      inputType &&
      (inputType === TYPE_INPUT_DATE ||
        inputType === TYPE_INPUT_DATE_TIME ||
        inputType === TYPE_INPUT_TIME)
    ) {
      return (
        <>
          {inputType === TYPE_INPUT_TIME && (
            <div className="form-group">
              <FormControl disabled={submitting}>
                <FormControlLabel
                  label={formatMessage(messages.unchangeableTime)}
                  className="form-label"
                  control={
                    <Field
                      name="parameters.unchangeable_time"
                      component={Checkbox}
                      type="checkbox"
                      color="primary"
                    />
                  }
                />
              </FormControl>
            </div>
          )}
          <div className="form-group">
            <FormControl
              disabled={
                submitting ||
                (values && values.parameters && !!values.parameters.dependency)
              }
              onChange={() => {
                if (!canSetCurrentDatetime) {
                  handlers.handleLookupWithTypeEditableChange(true)
                }

                setCanSetCurrentDatetime(!canSetCurrentDatetime)
              }}>
              <FormControlLabel
                label={formatMessage(messages.canSetCurrentDatetimeMessage)}
                className="form-label"
                control={
                  <Field
                    name="parameters.can_set_current_datetime"
                    component={Checkbox}
                    type="checkbox"
                    color="primary"
                  />
                }
              />
            </FormControl>
          </div>
          {inputType &&
            (inputType === TYPE_INPUT_DATE ||
              inputType === TYPE_INPUT_DATE_TIME) && (
              <>
                {inputType === TYPE_INPUT_DATE &&
                  renderIsLookupInputCheckbox(
                    isLookupDate,
                    setIsLookupDate,
                    handlers.handleLookupWithTypeConditionClear,
                    submitting,
                  )}
                {isLookupDate &&
                  renderLookupWithTypeParameters(
                    STRING_OR_DATE_INPUT_CONDITION_TYPES,
                  )}
                <div
                  className={cn('form-group', {
                    hide: !dependencyFormOpened || isLookupDate,
                  })}>
                  {parameters.map(({ value, properties }) => {
                    if (value === PARAMETER_DEPENDENCY) {
                      const [, dependencyValues] = properties
                      const { options: valuesOptions } = dependencyValues
                      const isInputSelectDisabled =
                        submitting || !jobTask || !dependencyInputs.size

                      return (
                        <div key={value} className="dependencies-container">
                          <Field
                            name={`parameters.${value}.rule`}
                            label={formatMessage(messages.shouldBe)}
                            component={Select}
                            disabled={submitting}
                            formControlProps={{
                              required: dependencyFormOpened,
                              fullWidth: true,
                              className: 'form-group',
                            }}>
                            {valuesOptions.map(value => (
                              <MenuItem button key={value} value={value}>
                                {formatMessage({ id: value })}
                              </MenuItem>
                            ))}
                          </Field>
                          <Field
                            name={`parameters.${value}.input`}
                            label={formatMessage(messages.then)}
                            component={Select}
                            disabled={isInputSelectDisabled}
                            formControlProps={{
                              required: dependencyFormOpened,
                              fullWidth: true,
                              className: 'form-group',
                            }}>
                            {dependencyInputs.map(
                              ({ id: dependencyId, title }) => (
                                <MenuItem button key={id} value={dependencyId}>
                                  {title}
                                </MenuItem>
                              ),
                            )}
                          </Field>
                          <IconButton onClick={handlers.handleDependencyClear}>
                            <Icon>delete</Icon>
                          </IconButton>
                        </div>
                      )
                    }

                    return null
                  })}
                </div>
                {!dependencyFormOpened && !isLookupDate && (
                  <Button
                    className="add-dependency-link"
                    onClick={() => {
                      setDependencyFormOpened(true)
                    }}>
                    {formatMessage(messages.addDependency)}
                  </Button>
                )}
              </>
            )}
        </>
      )
    }

    if (inputType && inputType === TYPE_INPUT_BOOLEAN) {
      return parameters.map(field => {
        const { type, title, value, required, options } = field

        if (type === TYPE_SELECT) {
          return (
            <Field
              key={value}
              name={`parameters.${value}`}
              type="select"
              label={title}
              component={Select}
              disabled={submitting}
              validate={getValidator(VALIDATOR_IS_EMPTY)}
              formControlProps={{
                required,
                fullWidth: true,
                className: 'form-group',
              }}>
              {options.map(item => (
                <MenuItem key={item} value={item}>
                  {formatMessage({ id: `boolean_input_display_${item}` })}
                </MenuItem>
              ))}
            </Field>
          )
        }

        return getFormField(field, submitting)
      })
    }

    if (
      inputType &&
      (inputType === TYPE_INPUT_DATE || inputType === TYPE_INPUT_DATE_TIME)
    ) {
      return (
        <>
          {(inputType === TYPE_INPUT_DATE ||
            inputType === TYPE_INPUT_DATE_TIME) && (
            <>
              {inputType === TYPE_INPUT_DATE &&
                renderIsLookupInputCheckbox(
                  isLookupDate,
                  setIsLookupDate,
                  handlers.handleLookupWithTypeConditionClear,
                  submitting,
                )}
              {isLookupDate &&
                renderLookupWithTypeParameters(
                  STRING_OR_DATE_INPUT_CONDITION_TYPES,
                )}
              <div
                className={cn('form-group', {
                  hide: !dependencyFormOpened || isLookupDate,
                })}>
                {parameters.map(({ value, properties }) => {
                  if (value === PARAMETER_DEPENDENCY) {
                    const [, dependencyValues] = properties
                    const { options: valuesOptions } = dependencyValues
                    const isInputSelectDisabled =
                      submitting || !jobTask || !dependencyInputs.size

                    return (
                      <div key={value} className="dependencies-container">
                        <Field
                          name={`parameters.${value}.rule`}
                          label={formatMessage(messages.shouldBe)}
                          component={Select}
                          disabled={submitting}
                          formControlProps={{
                            required: dependencyFormOpened,
                            fullWidth: true,
                            className: 'form-group',
                          }}>
                          {valuesOptions.map(value => (
                            <MenuItem button key={value} value={value}>
                              {formatMessage({ id: value })}
                            </MenuItem>
                          ))}
                        </Field>
                        <Field
                          name={`parameters.${value}.input`}
                          label={formatMessage(messages.then)}
                          component={Select}
                          disabled={isInputSelectDisabled}
                          formControlProps={{
                            required: dependencyFormOpened,
                            fullWidth: true,
                            className: 'form-group',
                          }}>
                          {dependencyInputs.map(({ id, title }) => (
                            <MenuItem button key={id} value={id}>
                              {title}
                            </MenuItem>
                          ))}
                        </Field>
                        <IconButton onClick={handlers.handleDependencyClear}>
                          <Icon>delete</Icon>
                        </IconButton>
                      </div>
                    )
                  }

                  return null
                })}
              </div>
            </>
          )}
          {!dependencyFormOpened && !isLookupDate && (
            <Button
              className="add-dependency-link"
              onClick={() => {
                setDependencyFormOpened(true)
              }}>
              {formatMessage(messages.addDependency)}
            </Button>
          )}
        </>
      )
    }

    if (
      inputType &&
      inputType === TYPE_INPUT_SIGNATURE &&
      featureFlags.DIGITAL_SIGNATURE
    ) {
      return (
        <FormControlLabel
          label={formatMessage(messages.useWorkerSignatureTemplate)}
          disabled={submitting}
          control={
            <Field
              name="parameters.use_worker_signature"
              component={Checkbox}
              type="checkbox"
              color="primary"
              disabled={submitting}
            />
          }
        />
      )
    }
  }
  /* eslint-enable max-statements */

  return (
    <div className="container-fluid no-breadcrumb">
      <Typography variant="h5" className="headline">
        <IconButton size="medium" className="btn-back" onClick={goBack}>
          <IconBack />
        </IconButton>
        {formatMessage(messages.jobInputsInfo)}
      </Typography>
      <Form
        initialValues={formState}
        onSubmit={handleSubmitForm}
        {...(featureFlags.INSTRUCTIONS_TEXT_EDITOR
          ? {
              subscription: {
                submitting: true,
                touched: true,
                invalid: true,
                values: true,
              },
            }
          : {})}
        mutators={{
          handleTypeChange: (
            [
              {
                target: { value },
              },
            ],
            state,
            { changeValue },
          ) => {
            const findType = inputTypeOptions.find(({ type }) => type === value)

            setDynamicOption([langFields])
            setInputType(findType?.type || value)
            setParameters(findType?.parameters || [])
            changeValue(state, 'type', () => value)
          },
          handleWorkflowChange: (
            [
              {
                target: { value },
              },
            ],
            state,
            { changeValue },
          ) => {
            setJobWorkflow(value)
            changeValue(state, 'workflow', () => value)
            setJobTask(null)
            changeValue(state, 'task', () => null)
            setInputGroup(null)
            changeValue(state, 'input_group', () => null)
          },
          handleTaskChange: (
            [
              {
                target: { value },
              },
            ],
            state,
            { changeValue },
          ) => {
            setInputGroup(null)
            changeValue(state, 'input_group', () => null)
            setJobTask(value)
            changeValue(state, 'task', () => value)
          },
          handleInputGroupChange: (
            [
              {
                target: { value },
              },
            ],
            state,
            { changeValue },
          ) => {
            setInputGroup(value)
            changeValue(state, 'input_group', () => value)
          },
          handleInputGroupClear: (value, state, { changeValue }) => {
            setInputGroup(null)
            changeValue(state, 'input_group', () => null)

            if (isLookupNumber || isLookupString || isLookupDate) {
              changeValue(
                state,
                `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.creates_lookup_object`,
                () => false,
              )
            }
          },
          handleImagesChange: ([value], state, { changeValue }) => {
            changeValue(
              state,
              'parameters.options_source',
              () => PARAMETER_IMAGES,
            )
            changeValue(state, 'parameters.images', () => value)
          },
          handleOptionsSourceChange: (
            [
              ,
              {
                props: { value },
              },
            ],
            state,
            { changeValue },
          ) => {
            changeValue(state, 'parameters.options_source', () => value)
          },
          handleLookupTablesSourceChange: (
            [
              {
                target: { value },
              },
            ],
            state,
            { changeValue },
          ) => {
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions`,
              () => [],
            )
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.column`,
              () => [],
            )
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.table`,
              () => value,
            )
          },
          handleLookupTablesColumnChange: (
            [
              ,
              {
                props: { value },
              },
            ],
            state,
            { changeValue },
          ) => {
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.column`,
              () => value,
            )
          },
          handleLookupConditionChange: (
            [
              ,
              {
                props: { value, index },
              },
            ],
            state,
            { changeValue },
          ) => {
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions[${index}].inputs`,
              () => value,
            )
          },
          handleLookupConditionClear: ([index], state, { changeValue }) => {
            const {
              formState: {
                values: {
                  parameters: {
                    lookup_table_source: { conditions },
                  },
                },
              },
            } = state
            const filteredConditions = conditions.filter((_, i) => i !== index)
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions`,
              () => filteredConditions,
            )
            if (!filteredConditions?.length) {
              setDisplayConditions(false)
            }
          },
          handlerAddNewLookupCondition: ([type], state, { changeValue }) => {
            const conditions =
              state.formState.values?.parameters?.lookup_table_source
                ?.conditions ?? []
            const newConditions = [...conditions, { type, inputs: [] }]
            const { type: inputType } = state.formState.values
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions`,
              () => newConditions,
            )

            if (!displayConditions) {
              setDisplayConditions(true)
            }

            if (
              inputType === TYPE_INPUT_NUMBER &&
              newConditions.length > 1 &&
              newConditions[0].type === LOOKUP_DISPLAY_TYPE
            ) {
              changeValue(
                state,
                `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.editable`,
                () => true,
              )
            }
          },
          handleLookupWithTypeConditionChange: (
            [value, index],
            state,
            { changeValue },
          ) => {
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions[${index}]`,
              () => value,
            )

            const createsLookupObject =
              state.formState.values?.parameters?.lookup_table_source
                ?.creates_lookup_object ?? false

            if (value.type !== 'display' && createsLookupObject) {
              setIsCreatesNewRowChecked(false)
              changeValue(
                state,
                `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.creates_lookup_object`,
                () => false,
              )
            }
          },
          handleLookupWithTypeConditionClear: (
            value,
            state,
            { changeValue },
          ) => {
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions`,
              () => [{ type: 'display', inputs: [] }],
            )
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.editable`,
              () => editableDisabled,
            )
          },
          handleLookupEditableClear: (value, state, { changeValue }) => {
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.editable`,
              () => undefined,
            )
          },
          handleLookupWithTypeEditableChange: (
            [value],
            state,
            { changeValue },
          ) => {
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.editable`,
              () => value,
            )
          },
          handleEqualToSiteNameChange: (value, state, { changeValue }) => {
            const {
              formState: {
                values: {
                  parameters: {
                    lookup_table_source: { equal_to_site_name },
                  },
                },
              },
            } = state
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.conditions`,
              () => [],
            )
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.unique`,
              () => false,
            )
            setDisplayConditions(false)
            setEqualToSiteName(equal_to_site_name)
          },
          handleCreatesNewRowInTheTableChange: (
            [value],
            state,
            { changeValue },
          ) => {
            const isOptionAllowed = !!allowedTableColumns
              .toJS()
              .find(
                columnId =>
                  activeLookupTableColumn &&
                  columnId === activeLookupTableColumn.key,
              )

            if (!isOptionAllowed) {
              setActiveLookupTableColumn(null)
              changeValue(
                state,
                `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.column`,
                () => [],
              )
            }

            setIsCreatesNewRowChecked(value)
            changeValue(
              state,
              `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.creates_lookup_object`,
              () => value,
            )

            if (value) {
              changeValue(
                state,
                `parameters.${PARAMETER_LOOKUP_TABLES_SOURCE}.editable`,
                () => value,
              )
            }
          },
          handleParametersOptionsSet: ([value], state, { changeValue }) => {
            changeValue(state, 'parameters.options', () => value)
          },
          handleParametersClear: ([value], state, { changeValue }) => {
            changeValue(state, 'parameters', () => value)
          },
          handleDependencyClear: (value, state, { changeValue }) => {
            changeValue(state, 'parameters', () => ({
              can_set_current_datetime: true,
            }))
            setDependencyFormOpened(false)
          },
          handleOptionsClear: (value, state, { changeValue }) => {
            setDynamicOption([langFields])
            changeValue(state, 'parameters.images', () => {})
            changeValue(state, 'parameters.options', () => {})
            changeValue(state, 'parameters.options_source', () => {})
          },
          handleSetDynamicValue: ([field, value], state, { changeValue }) => {
            changeValue(state, field, () => value)
          },
          handleStringParametersClear: (value, state, { changeValue }) => {
            const {
              lastFormState: {
                values: { parameters },
              },
            } = state
            Object.keys(parameters).forEach(parameter => {
              if (parameter && parameter !== PARAMETER_BARCODE) {
                changeValue(state, `parameters.${parameter}`, () => {})
              }
            })
          },
          handleTitleClear: (value, state, { changeValue }) => {
            changeValue(state, `title.${value[0]}`, () => {})
          },
          handleShortNameClear: (value, state, { changeValue }) => {
            changeValue(state, `short_name.${value[0]}`, () => null)
          },
          handleInstructionsClear: (value, state, { changeValue }) => {
            changeValue(state, `instructions.${value[0]}`, () => {})
          },
        }}
        render={({ handleSubmit, submitting, values, form: { mutators } }) => {
          const { parameters: formParams, job_preview, task_preview } =
            values || {}
          const preview = job_preview || task_preview
          let disableKey = null
          const isEmptyCondition =
            values?.parameters &&
            values?.parameters[PARAMETER_LOOKUP_TABLES_SOURCE] &&
            values?.type === TYPE_INPUT_TEXT &&
            !values?.parameters[PARAMETER_LOOKUP_TABLES_SOURCE]?.condition

          if (formParams && Object.keys(formParams).length) {
            Object.entries(formParams).forEach(([key, value]) => {
              if (
                (key === PARAMETER_BARCODE || key === PARAMETER_NUMBERS_ONLY) &&
                value
              ) {
                disableKey = key
              }
            })
          }

          if (values?.parameters?.dependency) {
            const parametersValue = values.parameters
            delete parametersValue.can_set_current_datetime
          }

          return (
            <form onSubmit={handleSubmit} className="form-basic">
              <TitleInput
                handleTitleClear={mutators.handleTitleClear}
                formState={formState.title}>
                {Object.values(APP_LANGUAGES).map(({ key }) => {
                  const validators = [VALIDATOR_IS_LESS_THEN_255_SYMBOLS]

                  if (isEnglish(key)) {
                    validators.push(VALIDATOR_IS_EMPTY)
                  }

                  return (
                    <Field
                      required={isEnglish(key)}
                      name={`title[${key}]`}
                      key={`${key}title`}
                      type="text"
                      lang={key}
                      label={`${key} ${formatMessage(messages.title)}`}
                      component={Input}
                      className="form-control"
                      validate={getValidator(validators)}
                      parse={value => {
                        if (isEnglish(key)) {
                          setEnTitle(value)
                        }

                        return value
                      }}
                    />
                  )
                })}
              </TitleInput>
              <Field
                required
                name="workflow"
                label={formatMessage(messages.jobWorkflow)}
                component={SelectInput}
                disabled={submitting}
                onChange={(args, state, utils) => {
                  mutators.handleWorkflowChange(args, state, utils)

                  if (
                    inputType === TYPE_INPUT_DATE ||
                    inputType === TYPE_INPUT_DATE_TIME
                  ) {
                    mutators.handleParametersClear({
                      can_set_current_datetime: true,
                    })
                    setDependencyFormOpened(false)
                  }
                }}
                validate={getValidator(VALIDATOR_IS_EMPTY)}>
                {jobWorkflows.map(({ id: jobId, title: jobTitle }) => (
                  <MenuItem button key={jobId} value={jobId}>
                    {jobTitle}
                  </MenuItem>
                ))}
              </Field>
              <Field
                required
                name="task"
                label={formatMessage(messages.jobTaskWorkflow)}
                component={SelectInput}
                disabled={submitting || !jobWorkflowTasks.size}
                onChange={(args, state, utils) => {
                  mutators.handleTaskChange(args, state, utils)

                  if (
                    inputType === TYPE_INPUT_DATE ||
                    inputType === TYPE_INPUT_DATE_TIME
                  ) {
                    mutators.handleParametersClear({
                      can_set_current_datetime: true,
                    })
                  }
                }}
                validate={getValidator(VALIDATOR_IS_EMPTY)}>
                {jobWorkflowTasks.map(
                  ({ id: jobTaskId, title: jobTaskTitle }) => (
                    <MenuItem button key={jobTaskId} value={jobTaskId}>
                      {jobTaskTitle}
                    </MenuItem>
                  ),
                )}
              </Field>
              <div className="form-group">
                <Field
                  name="input_group"
                  label={formatMessage(messages.inputGroup)}
                  component={SelectInput}
                  disabled={submitting || !jobWorkflowInputGroups.size}
                  onChange={(args, state, utils) => {
                    mutators.handleInputGroupChange(args, state, utils)

                    if (
                      inputType === TYPE_INPUT_DATE ||
                      inputType === TYPE_INPUT_DATE_TIME
                    ) {
                      mutators.handleParametersClear({
                        can_set_current_datetime: true,
                      })
                    }
                  }}>
                  {jobWorkflowInputGroups.map(
                    ({ id: jobInputGroupId, title: inputGroupTitle }) => (
                      <MenuItem
                        button
                        key={jobInputGroupId}
                        value={jobInputGroupId}>
                        {inputGroupTitle}
                      </MenuItem>
                    ),
                  )}
                </Field>
                {!!inputGroup && (
                  <ClearIcon
                    className={classes.remove_icon}
                    onClick={mutators.handleInputGroupClear}
                  />
                )}
              </div>
              <Field
                required
                name="type"
                label={formatMessage(messages.inputType)}
                component={SelectInput}
                disabled={submitting || hasEntityId}
                validate={getValidator(VALIDATOR_IS_EMPTY)}
                onChange={(args, state, utils) => {
                  mutators.handleTypeChange(args, state, utils)
                  const checkForSignatureType =
                    args.target.value === TYPE_INPUT_SIGNATURE &&
                    featureFlags.DIGITAL_SIGNATURE
                      ? { use_worker_signature: true }
                      : {}
                  mutators.handleParametersClear(
                    args.target.value === TYPE_INPUT_DATE ||
                      args.target.value === TYPE_INPUT_DATE_TIME ||
                      args.target.value === TYPE_INPUT_TIME
                      ? { can_set_current_datetime: true }
                      : checkForSignatureType,
                  )

                  if (args.target.value === TYPE_INPUT_DATE) {
                    setDisplayConditions(false)
                    setIsLookupDate(false)
                  }

                  setParameterValue('')
                }}>
                {inputTypeOptions.map(({ type }) => (
                  <MenuItem button key={type} value={type}>
                    {formatMessage({ id: type })}
                  </MenuItem>
                ))}
              </Field>
              {parameters &&
                (!!parameters.length || !!Object.keys(parameters).length) &&
                !(
                  Object.keys(parameters).length === 1 &&
                  parameters[0].value === 'can_only_take_pictures_in_mobile_app'
                ) && (
                  <div className={`form-group ${classes.form_inside}`}>
                    <Typography gutterBottom variant="h6">
                      {formatMessage(messages.parameters)}
                    </Typography>
                    {getDynamicField(
                      mutators,
                      submitting,
                      disableKey,
                      values,
                      isEmptyCondition,
                    )}
                  </div>
                )}
              <Field
                required
                name="position"
                type="number"
                label={formatMessage(messages.position)}
                component={Input}
                disabled={submitting}
                parse={val => {
                  if (val === '') {
                    return val
                  }

                  return +val
                }}
                validate={getValidator(VALIDATOR_IS_EMPTY)}
              />
              <FormControl>
                <FormControlLabel
                  label={formatMessage({ id: 'preview_details_show' })}
                  disabled={submitting}
                  className="form-label"
                  control={
                    <Field
                      name="job_preview"
                      component={Checkbox}
                      type="checkbox"
                      color="primary"
                      disabled={submitting}
                    />
                  }
                />
              </FormControl>
              <FormControl>
                <FormControlLabel
                  label={formatMessage({ id: 'task_preview_details_show' })}
                  disabled={submitting}
                  className="form-label"
                  control={
                    <Field
                      name="task_preview"
                      component={Checkbox}
                      type="checkbox"
                      color="primary"
                      disabled={submitting}
                    />
                  }
                />
              </FormControl>
              <div
                className={
                  preview ? 'preview-block' : 'preview-block disabled'
                }>
                <div
                  className={
                    preview ? 'preview-title' : 'preview-title disabled'
                  }>
                  {formatMessage({ id: 'preview_details' })}
                </div>
                <TitleInput
                  handleTitleClear={mutators.handleShortNameClear}
                  formState={formState.short_name}
                  disabled={submitting || !preview}
                  backgroundButton>
                  {Object.values(APP_LANGUAGES).map(({ key }) => (
                    <Field
                      key={`${key}short_name`}
                      label={`${key} ${formatMessage({ id: 'short_title' })}`}
                      name={`short_name[${key}]`}
                      disabled={submitting || !preview}
                      type="text"
                      lang={key}
                      validate={getValidator(
                        VALIDATOR_IS_LESS_THEN_255_SYMBOLS,
                      )}
                      parse={val => (val === '' ? null : val)}
                      component={Input}
                    />
                  ))}
                </TitleInput>
              </div>
              <TitleInput
                handleTitleClear={mutators.handleInstructionsClear}
                formState={formState.instructions}>
                {Object.values(APP_LANGUAGES).map(({ key }) => (
                  <Field
                    name={`instructions[${key}]`}
                    key={`${key}_instructions`}
                    type="text"
                    lang={key}
                    label={`${key} ${formatMessage(messages.instructions)}`}
                    component={
                      featureFlags.INSTRUCTIONS_TEXT_EDITOR
                        ? props => (
                            <TextEditor
                              placeholder={`${key} ${formatMessage(
                                messages.instructions,
                              )}`}
                              {...props}
                            />
                          )
                        : TextArea
                    }
                    className="form-control"
                    disabled={submitting}
                  />
                ))}
              </TitleInput>
              <InputLabel htmlFor="filePicker">
                <Field
                  name="image_path"
                  label="image"
                  className="form-control"
                  disabled={submitting}>
                  {({ input: { value, onChange, ...input } }) => (
                    <input
                      {...input}
                      className={classes.file_input}
                      id="filePicker"
                      type="file"
                      name="image_path"
                      accept="image/jpg, image/jpeg, image/png"
                      onChange={({ target: { files } }) => onChangeFile(files)}
                    />
                  )}
                </Field>
                {!imagePath && (
                  <div className={classes.field_input}>
                    <IconUploadFile className={classes.field_icon} />
                    {formatMessage({ id: 'upload_png_jpg' })}
                  </div>
                )}
              </InputLabel>
              {imagePath && (
                <div className={`form-group ${classes.image_wrap}`}>
                  <TextField
                    fullWidth
                    readOnly
                    type="text"
                    label={formatMessage({ id: 'image_path' })}
                    value={imagePath}
                  />
                  <ClearIcon
                    className={classes.remove_icon}
                    onClick={removeImage}
                  />
                </div>
              )}
              <Field
                name="youtube_video_link"
                type="text"
                label={formatMessage({ id: 'youtube_video_link' })}
                component={Input}
                className="form-control"
                disabled={submitting}
                validate={getValidator(VALIDATOR_IS_YOUTUBE_LINK)}
              />
              {inputType &&
                (inputType === TYPE_INPUT_FILE ||
                  inputType === TYPE_INPUT_MULTIPLE_FILES) && (
                  <div className="form-group">
                    <FormControl required>
                      <FormControlLabel
                        label={formatMessage(messages.canOnlyTakePictures)}
                        disabled={submitting}
                        className="form-label"
                        control={
                          <Field
                            name="parameters.can_only_take_pictures_in_mobile_app"
                            component={Checkbox}
                            type="checkbox"
                            color="primary"
                            disabled={submitting}
                          />
                        }
                      />
                    </FormControl>
                  </div>
                )}
              <div className="form-group">
                <FormControl required>
                  <FormControlLabel
                    label={formatMessage(messages.required)}
                    disabled={submitting}
                    className="form-label"
                    control={
                      <Field
                        name="required"
                        component={Checkbox}
                        type="checkbox"
                        color="primary"
                        disabled={submitting}
                      />
                    }
                  />
                </FormControl>
              </div>
              <div className="form-group">
                <FormControl required>
                  <FormControlLabel
                    label={formatMessage(messages.active)}
                    disabled={submitting}
                    className="form-label"
                    control={
                      <Field
                        name="enabled"
                        component={Checkbox}
                        type="checkbox"
                        color="primary"
                        disabled={submitting}
                      />
                    }
                  />
                </FormControl>
              </div>
              <Button
                href={null}
                type="submit"
                color="primary"
                size="medium"
                variant="contained"
                onClick={handleSubmit}
                disabled={submitting}>
                {formatMessage(messages.save)}
              </Button>
            </form>
          )
        }}
      />
    </div>
  )
}

JobSingleInput.propTypes = {
  formData: PropTypes.object.isRequired,
  jobWorkflows: PropTypes.object.isRequired,
  jobWorkflowTasks: PropTypes.object.isRequired,
  jobWorkflowInputGroups: PropTypes.object.isRequired,
  inputTypes: PropTypes.object.isRequired,
  inputOptionsSource: PropTypes.object.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  dependencyInputs: PropTypes.instanceOf(List),
  fetchDependencyInputs: PropTypes.func,
  showNotice: PropTypes.func,
  uploadFiles: PropTypes.func,
  saveJobInputsInfo: PropTypes.func,
  jobInputsClearDetails: PropTypes.func,
  fetchJobWorkflows: PropTypes.func,
  fetchJobWorkflowTasks: PropTypes.func,
  fetchJobWorkflowInputGroups: PropTypes.func,
  fetchInputTypes: PropTypes.func,
  fetchJobWorkflowInputItem: PropTypes.func,
  fetchInputsOptionsSource: PropTypes.func,
  fetchLookupTablesSource: PropTypes.func,
  fetchLookupConditions: PropTypes.func,
}

JobSingleInput.defaultProps = {
  dependencyInputs: List([]),
  showNotice: () => {},
  uploadFiles: () => {},
  saveJobInputsInfo: () => {},
  jobInputsClearDetails: () => {},
  fetchJobWorkflows: () => {},
  fetchJobWorkflowTasks: () => {},
  fetchJobWorkflowInputGroups: () => {},
  fetchInputTypes: () => {},
  fetchJobWorkflowInputItem: () => {},
  fetchInputsOptionsSource: () => {},
  fetchLookupTablesSource: () => {},
  fetchLookupConditions: () => {},
  fetchDependencyInputs: () => {},
}

export default connect(
  state => ({
    formData: state.getIn(['jobInputsAdmin', 'formData']),
    jobWorkflows: state.getIn(['jobInputsAdmin', 'jobWorkflows']),
    jobWorkflowTasks: state.getIn(['jobInputsAdmin', 'jobWorkflowTasks']),
    jobWorkflowInputGroups: state.getIn([
      'jobInputsAdmin',
      'jobWorkflowInputGroups',
    ]),
    inputTypes: state.getIn(['jobInputsAdmin', 'inputTypes']),
    inputOptionsSource: state.getIn(['jobInputsAdmin', 'optionsSource']),
    inputLookupTablesSource: state.getIn([
      'jobInputsAdmin',
      'lookupTablesSource',
    ]),
    inputLookupConditions: state.getIn(['jobInputsAdmin', 'lookupConditions']),
    allowedTableColumns: state.getIn(['jobInputsAdmin', 'allowedTableColumns']),
    dependencyInputs: state.getIn(['jobInputsAdmin', 'dependencyInputs']),
    numberInputs: state.getIn(['jobInputsAdmin', 'numberInputs']).toJS(),
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
  }),
  {
    showNotice,
    uploadFiles,
    saveJobInputsInfo,
    jobInputsClearDetails,
    fetchJobWorkflows,
    fetchJobWorkflowTasks,
    fetchJobWorkflowInputGroups,
    fetchInputTypes,
    fetchTaskNumberInputs,
    fetchJobWorkflowInputItem,
    fetchInputsOptionsSource,
    fetchLookupTablesSource,
    fetchLookupConditions,
    fetchDependencyInputs,
    fetchAllowedLookupColumns,
  },
)(injectIntl(JobSingleInput))
